export enum TypeCondition {
  EDIT = 'edit',
  CREATE = 'create',
}

export interface Props {
  type: TypeCondition;
}
